import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { MobileDetectionService } from '../services/mobile-detection.service';

@Injectable({
  providedIn: 'root'
})
export class MobileGuard implements CanActivate {
  
  constructor(
    private mobileDetectionService: MobileDetectionService,
    private router: Router
  ) {}

  canActivate(): boolean {
    // If user is on mobile, redirect to mobile WIP screen
    if (this.mobileDetectionService.shouldShowMobileWIP()) {
      this.router.navigate(['/mobile-wip']);
      return false;
    }
    
    // Allow access for desktop/tablet users
    return true;
  }
}
